import * as React from 'react'
import { useEffect } from 'react'
import { MapViewDialogContent } from './MapViewDialogContent'
import { ENTITY_TYPES } from '@sales-center/common'
import { MapViewFullScreenDialog } from './MapViewFullScreenDialog'
import { useData, useHandlers, useFilterPreferences } from './hooks'
import { setMapLinkClickedContactLocation } from '@user/store/map'
import { useAppDispatch } from '@user/store/hooks'

type Props = {
  onClose: () => void
  open: boolean
  center?: H.geo.Point
  entityId?: number
  entityType?: ENTITY_TYPES
  serviceLocationId?: number
  zoom?: number
}

export function MapViewDialog(props: Props) {
  const { onClose, open } = props
  const dispatch = useAppDispatch()
  const {
    searchDrawerOpen,
    setSearchDrawerOpen,
    filterDrawerOpen,
    setFilterDrawerOpen,
    addLeadDrawerOpen,
    setAddLeadDrawerOpen,
  } = useData()

  const { handleChangeView } = useHandlers({
    setSearchDrawerOpen,
    setFilterDrawerOpen,
    setAddLeadDrawerOpen,
  })

  // Update filter preferences when a contact location link is clicked
  useFilterPreferences({ open })

  // Clear Redux state when dialog closes
  useEffect(() => {
    if (!open) {
      dispatch(setMapLinkClickedContactLocation(null))
    }
  }, [open, dispatch])

  return (
    <MapViewFullScreenDialog
      open={open}
      onClose={onClose}
      onChangeViews={handleChangeView}
    >
      <MapViewDialogContent
        searchDrawerOpen={searchDrawerOpen}
        setSearchDrawerOpen={setSearchDrawerOpen}
        filterDrawerOpen={filterDrawerOpen}
        setFilterDrawerOpen={setFilterDrawerOpen}
        addLeadDrawerOpen={addLeadDrawerOpen}
        setAddLeadDrawerOpen={setAddLeadDrawerOpen}
        {...props}
      />
    </MapViewFullScreenDialog>
  )
}
